export { default } from './Menu';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Menu/index.js
// module id = 544
// module chunks = 121